import { render, staticRenderFns } from "./itemdelete.vue?vue&type=template&id=f4af74ea&scoped=true&"
import script from "./itemdelete.vue?vue&type=script&lang=js&"
export * from "./itemdelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4af74ea",
  null
  
)

export default component.exports